export const getCompletedSurveys = () => {
  return window.localStorage.getItem("completedSurveys")
    ? // @ts-ignore
      JSON.parse(window.localStorage.getItem("completedSurveys"))
    : [];
};
